import { meta, script, link } from '../tags';

const attributes = {
    '*': [ 'data-*', 'itemprop', 'role' ],
    meta: meta.allowedAttributes,
    script: script.allowedAttributes,
    link: link.allowedAttributes
}

const tags = [ 'title', 'meta', 'script', 'link' ];

const allowVulnerableTags = true;

export default {
    attributes,
    tags,
    allowVulnerableTags
};
